module.exports = __webpack_public_path__ + "static/media/engineering-skills.2d227609.png";